export default function LogsPage() {
  return (
    <div className="page-shell space-y-6" data-testid="logs-page">
      <div className="page-header">
        <div className="app-page-header">
          <h1 className="app-page-title">Loglar</h1>
          <p className="app-page-subtitle">Sistem loglar\u0131 ve i\u015flem ge\u00e7mi\u015fi.</p>
        </div>
      </div>
      <div className="surface-card p-6">
        <p className="text-sm text-muted-foreground">Log kay\u0131tlar\u0131 yak\u0131nda burada g\u00f6r\u00fcnecek.</p>
      </div>
    </div>
  );
}
